import { format } from "date-fns";

export const AUDIT_FIELD_LABELS = {
    vendor_name: "Vendor Name",
    email: "Vendor Email(s)",
    account_number: "Account Number",
    currency: "Currency",
    internal_note: "Internal Note",
    default_po_note: "Default PO Note",
    document_links: "Document Links",
    payment_terms: "Payment Terms",
    deposit_first: "Deposit 1 %",
    deposit_second: "Deposit 2 %",
    balance: "Balance %",
    credit: "Credit %",
    deposit_first_days: "Deposit 1 Days",
    deposit_second_days: "Deposit 2 Days",
    balance_days: "Balance Days",
    credit_days: "Credit Days",
    shipping_days: "Shipping Days",
    deposit: "Deposit %",
    deposit_days: "Deposit Days",
    eden_status: "Status",
    logo: "Logo",
    "address.name": "Address Name",
    "address.address1": "Address",
    "address.address2": "Address 2",
    "address.city": "City",
    "address.state": "State",
    "address.zip": "Zip / Postal Code",
    "address.country": "Country",
    "address.phone": "Phone",
};

export const AUDIT_HIDDEN_FIELDS = new Set(["id", "sh_legacy_id", "sh_vendor_id", "partner_vendor_id"]);

export function formatAuditFieldLabel(field) {
    if (AUDIT_FIELD_LABELS[field]) return AUDIT_FIELD_LABELS[field];
    return field
        .replace(/^address\./, "Address ")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatAuditValue(value) {
    if (value === null || value === undefined || value === "") return "\u2014";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}

export function formatAuditTimestamp(value) {
    if (!value) return "";
    try {
        return format(new Date(value), "MMM d, yyyy 'at' h:mm a");
    } catch {
        return "";
    }
}
